<template>
    <card shadow type="secondary" >
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-8">
                        <h3 class="mb-0">Standort editieren</h3>
                    </div>
                </div>
            </div>
            <template>
                <tabs>
                    <tab-pane title="Allgemein">
                        <form @submit.prevent="editLocation($route.params.id)">
                            <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                            <h6 class="heading-small text-muted mb-4">Angaben zum Standort</h6>
                            <locationform ref="LForm" :loading-prop="isLoading"/>
                            <!-- Address -->
                            <button class="btn btn-icon my-4 btn-primary" :key="'btn2'+tick" :disabled="isLoading">
                                <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                                <span class="btn-inner--text">Standortdaten ändern</span></button>
                        </form>
                    </tab-pane>
                    <tab-pane v-if="showLocationData().isProtocolAllowed" title="Fragebögen">
                        <div class="row">
                            <div class="col"><h3>Fragebögen an diesem Standort</h3></div>
                            <div class="col text-right">
                                <base-dropdown position="right">  <!--- v-if="showLocationData.isProtocolAllowed" --->
                                    <base-button slot="title" icon="ni ni-fat-add" size="sm" class="dropdown-toggle">
                                        hinzufügen
                                    </base-button>
                                    <a v-for="form in forms" :key="form.id" class="dropdown-item align-right" href="#" @click="addLocForm('/api/locations/'+$route.params.id,form['@id'])">{{form.name}} hinzufügen</a>
                                </base-dropdown>
                            </div>
                        </div>
                        <base-table class="table align-items-center table-flush"
                                    tbody-classes="list"
                                    :data="locationforms">
                            <template slot="columns">
                                <th>Name</th>
                                <th></th>
                            </template>
                            <template slot-scope="{row,index}">
                                <th v-if="isLoadingForms" scope="row" >
                                    <div class="loading"> </div>
                                </th>
                                <th v-else scope="row" v-html="row.form.name">
                                </th>
                                <td  :key="tick">
                                    <div v-if="isLoadingForms" class="loading-button"> </div><div v-else>
                                        <base-button v-if="!row.delete" type="primary" icon="far fa-trash-alt" v-on:click="deleteConfirmation(index)"></base-button>
                                        <div v-if="row.delete" style="margin-top: 1rem;"><span  class="text-danger">Sicher? <i class="fas fa-trash-alt"></i></span><br>
                                            <base-button v-if="row.delete" size="sm" type="danger" icon="fas fa-check" v-on:click="deleteLocForm(row.id)">Ja</base-button>
                                            <base-button v-if="row.delete" size="sm" type="info" icon="fas fa-times" v-on:click="deleteConfirmation(index)">Nein</base-button>
                                        </div>
                                    </div>
                                </td>
                            </template>
                        </base-table>
                        <!--- <base-alert v-else type="warning">Fragebögen sind in diesem Standort nicht enthalten.</base-alert>    --->
                    </tab-pane>
                    <tab-pane title="Aufgaben" v-if="showLocationData().isTaskAllowed">
                        <task-template-modal :location="$route.params.id" :show="showCreateTaskTemplate" :template="template" :key="'ttm'+tick" @modalClosed="$refs.tasktemplatelist.refreshData()"></task-template-modal>
                        <div class="row">
                            <div class="col-8"><h3>Aufgabenzeitpläne für diesen Standort</h3></div>
                            <div class="col-4 text-right">
                              <base-dropdown position="right">
                                <base-button slot="title" icon="ni ni-fat-add" size="sm" class="dropdown-toggle">
                                  hinzufügen
                                </base-button>
                                <a href="#" size="sm" @click.prevent="showTaskTemplateModal" class="dropdown-item">Neue Aufgabe</a>
                                <div class="dropdown-divider">Vorlagen</div>
                                <a href="#" size="sm" @click.prevent="() => { template = templates[0]; showTaskTemplateModal();}" class="dropdown-item">Jugendschutzkontrolle</a>
                                <a href="#" size="sm" @click.prevent="() => { template = templates[1]; showTaskTemplateModal();}" class="dropdown-item">Kontrolle InfoMaterialien</a>
                              </base-dropdown>
                            </div>

                        </div>
                        <task-template-list ref="tasktemplatelist" :location="$route.params.id"></task-template-list>
                    </tab-pane>
                    <tab-pane title="Dokumente" >
                        <location-document-modal :location="$route.params.id" :show="showCreateLocationDocument" :key="'ldm'+tick" @modalClosed="$refs.locationdocumentlist.refreshData()"></location-document-modal>
                        <div class="row">
                            <div class="col-8"><h3>Dokumente für diesen Standort</h3></div>
                            <div class="col-4 text-right"><base-button size="sm" @click="showLocationDocumentModal" icon="ni ni-fat-add"></base-button></div>
                        </div>
                        <location-document-list ref="locationdocumentlist" :location="$route.params.id"></location-document-list>
                    </tab-pane>
                </tabs>
            </template>
        </card>
</template>

<script>
    import Locationform from "@/views/Locations/Locationform";
    import TaskTemplateList from "@/views/TaskTemplates/list"
    import TaskTemplateModal from "@/views/TaskTemplates/TaskTemplateModal";
    import LocationDocumentModal from "@/views/LocationDocuments/Modal";
    import LocationDocumentList from "@/views/LocationDocuments/list";
    export default {
        name: "edit",
        components: {LocationDocumentModal, TaskTemplateModal, LocationDocumentList, TaskTemplateList, Locationform},
        data() {
            return {
                isLoading: true,
                isLoadingForms: false,
                locationforms: [
                    {form: {id: 0, name: ''}}
                ],
                forms: [],
                status: {
                    type: '',
                    msg: ''
                },
                showCreateTaskTemplate: {value: false},
                showCreateLocationDocument: {value: false},
                template: null,
                templates: [
                  {
                    description: 'Anwesenheit Minderjähriger in der Betriebsstätte kontrollieren und ggf. verweisen',
                    schedule: '0 8-23/2 * * *',
                    isPublic: true,
                    possibleAnswers: [{value:'Alles OK',action: null},{value:'Minderjähriger verwiesen',action:null}],
                    location: null,
                    type: 'Jugenschutzkontrolle',
                    user: null,
                    isActive: true,
                    isAutocomplete: true,
                    defaultAnswer: 'Alles OK'
                  },
                  {
                    description: 'Bitte prüfen, ob Info-Materialien sichtbar ausliegen. Gegebenenfalls sortieren und ordentlich auslegen. Wenn keine Infomaterialien mehr vorhanden, nachbestellen.',
                    schedule: '0 8-23/6 * * *',
                    isPublic: true,
                    possibleAnswers: [{value:'InfoMaterial liegt sichtbar aus',action: null},{value:'Infomaterial nachbestellt',action:null}],
                    location: null,
                    type: 'Kontrolle Informationsmaterialien',
                    user: null,
                    isActive: true,
                    isAutocomplete: true,
                    defaultAnswer: 'InfoMaterial liegt sichtbar aus'
                  }
                ],
                tick: 1,
                mount: false
            }
        },
        created() {
            this.showLocation(this.$route.params.id);
            this.getLocForms(this.$route.params.id).then(response => {
                this.locationforms = response.member;
            });
            this.getForms(this.$route.params.id).then(response => {
                this.forms = response.member;
            });
        },
        mounted() {
            this.mount = true;
        },
        computed: {

        },
        methods: {
            showTaskTemplateModal(){
                this.showCreateTaskTemplate.value = !this.showCreateTaskTemplate.value ;
                this.tick++;
            },
            showLocationDocumentModal(){
                this.showCreateLocationDocument.value = !this.showCreateLocationDocument.value;
                this.tick++;
            },
            showLocationData() {
                return (typeof this.$refs.LForm !== "undefined" && !this.isLoading && this.mount) ?  this.$refs.LForm.location : {isProtocolAllowed: false, isTaskAllowed: false, '@id': null};
            },
            locationdata () {
                return this.$refs.LForm.location;
            },
            showLocation(id) {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.isLoading = true;
                    this.tick++;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/locations/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.$refs.LForm.location = response;
                                if (typeof response.oasisid !== 'undefined') this.$refs.LForm.oasis = true;
                                if (typeof response.tuevcertificate !== 'undefined') this.$refs.LForm.tuev = true;
                                if (typeof response.oasiscert !== 'undefined') this.$refs.LForm.location.oasiscert = response.oasiscert['@id'];
                                if (typeof response.state !== 'undefined') this.$refs.LForm.location.state = response.state['@id'];
                                if (typeof response.customer !== 'undefined') this.$refs.LForm.location.customer = response.customer['@id'];
                                if (typeof response.juschgAction !== 'undefined') this.$refs.LForm.location.juschgAction = response.juschgAction['@id'];
                                if (typeof response.requestAction !== 'undefined') this.$refs.LForm.location.requestAction = response.requestAction['@id'];
                                if (typeof response.lockAction !== 'undefined') this.$refs.LForm.location.lockAction = response.lockAction['@id'];
                                if (typeof response.socialconcept !== 'undefined') this.$refs.LForm.location.socialconcept = response.socialconcept['@id'];
                                if (typeof response.selfLockAction !== 'undefined') this.$refs.LForm.location.selfLockAction = response.selfLockAction['@id'];
                                if (typeof response.foreignLockAction !== 'undefined') this.$refs.LForm.location.foreignLockAction = response.foreignLockAction['@id'];
                                if (typeof response.minorAction !== 'undefined') this.$refs.LForm.location.minorAction = response.minorAction['@id'];
                                if (typeof response.ageAction !== 'undefined') this.$refs.LForm.location.ageAction = response.ageAction['@id'];
                                this.isLoading = false;
                                this.tick++;
                            },
                            error => {
                                this.isLoading = false;
                                this.status =  {type: 'danger', msg: error};
                                this.tick++;
                            });
                });
            },
            editLocation(id) {
                return new Promise(() => {
                    this.status ={
                        type: '',
                        msg: ''
                    };
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = this.$refs.LForm.location;
                    senddata.tourintervall = parseInt(senddata.tourintervall);
                    senddata.minAge = parseInt(senddata.minAge);
                    senddata.entrances = parseInt(senddata.entrances);
                    senddata.concessions = parseInt(senddata.concessions);
                    senddata.gamblingmachines = parseInt(senddata.gamblingmachines);
                    senddata.entertainmentmachines = parseInt(senddata.entertainmentmachines);
                    senddata.squaremeters = parseInt(senddata.squaremeters);
                    senddata.limitCount = parseInt(senddata.limitCount);
                    senddata.additionalLimitCount = parseInt(senddata.additionalLimitCount);
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    this.tick++;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/locations/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.status =  {type: 'success', msg: 'Standort '+response.name+' (ID: '+response.id+') wurde editiert.'};
                                this.$store.dispatch('location/getLocationCollection');
                                this.tick++;
                            },
                            error => {
                                this.isLoading = false;
                                this.status =  {type: 'danger', msg: error};
                                this.tick++;
                            });
                });
            },
            getLocForms(id) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.isLoadingForms = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/location_forms?form.isActive=true&location=`+id+`&pagination=false`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve({
                                    totalItems: response['hydra:totalItems'],
                                    member: response['hydra:member']
                                });
                                this.isLoadingForms = false;
                            },
                            error => {
                                reject(error);
                                this.isLoadingForms = false;
                            });
                });
            },
            getForms() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.isLoadingForms = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/forms?isActive=true&pagination=false`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve({
                                    totalItems: response['hydra:totalItems'],
                                    member: response['hydra:member']
                                });
                                this.isLoadingForms = false;
                            },
                            error => {
                                reject(error);
                                this.isLoadingForms = false;
                            });
                });
            },
            addLocForm(lid,fid) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = {
                      form: fid,
                      location: lid
                    };
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoadingForms = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/location_forms`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                                this.getLocForms(this.$route.params.id).then(response => {
                                    this.locationforms = response.member;
                                    this.isLoadingForms = false
                                });
                            },
                            error => {
                                reject(error);
                                this.isLoadingForms = false
                            });
                });
            },
            deleteLocForm(id) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'DELETE',
                        headers: header,
                    };
                    this.isLoadingForms = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/location_forms/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                                this.getLocForms(this.$route.params.id).then(response => {
                                    this.locationforms = response.member;
                                    this.isLoadingForms = false
                                });

                            },
                            error => {
                                reject(error);
                                this.isLoadingForms = false
                            });
                });
            },
            deleteConfirmation(index) {
                if(typeof this.locationforms[index].delete === "undefined") {
                    this.locationforms[index].delete = false;
                }
                this.locationforms[index].delete = !this.locationforms[index].delete;
                this.tick++;
            },
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            }
        }
    }
</script>

<style scoped>

</style>